/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../common/currency';
import './users';
import '../../../bills/tender';
import '../../../common/entry_method';
import '../../../common/tender';
import '../../translation_types';
import '../../../common/payment';
import '../../../bills/contact_details';
import '../../../common/time';
import '../../../pago/external/payments_model';
import '../../../riskevaluation/external/external';
import '../../../bills/refund_v3';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "beemo": {
        "nested": {
          "api": {
            "nested": {
              "v2": {
                "nested": {
                  "models": {
                    "nested": {
                      "Tender": {
                        "fields": {
                          "type": {
                            "type": ".squareup.beemo.api.v2.models.Tender.Type",
                            "id": 1,
                            "rule": "optional"
                          },
                          "paymentToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "totalMoney": {
                            "type": ".squareup.common.Money",
                            "id": 3,
                            "rule": "optional"
                          },
                          "paymentNote": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "refundedMoney": {
                            "type": ".squareup.common.Money",
                            "id": 5,
                            "rule": "optional"
                          },
                          "creatorDetails": {
                            "type": ".squareup.beemo.api.v2.models.CreatorDetails",
                            "id": 6,
                            "rule": "optional"
                          },
                          "device": {
                            "type": ".squareup.beemo.api.v2.models.Device",
                            "id": 7,
                            "rule": "optional"
                          },
                          "state": {
                            "type": ".squareup.bills.Tender.State",
                            "id": 8,
                            "rule": "optional"
                          },
                          "entryMethod": {
                            "type": ".squareup.common.PayWithSquareEntryMethod",
                            "id": 10,
                            "rule": "optional"
                          },
                          "cardBrand": {
                            "type": ".squareup.common.tender.CardTenderType",
                            "id": 11,
                            "rule": "optional"
                          },
                          "felicaBrand": {
                            "type": ".squareup.common.tender.FelicaCard.FelicaBrand",
                            "id": 65,
                            "rule": "optional"
                          },
                          "isAfterpayVirtualCard": {
                            "type": "bool",
                            "id": 67,
                            "rule": "optional"
                          },
                          "cardCoBrand": {
                            "type": ".squareup.bills.CardTender.Card.CardCoBrand",
                            "id": 68,
                            "rule": "optional"
                          },
                          "panSuffix": {
                            "type": "string",
                            "id": 12,
                            "rule": "optional"
                          },
                          "processingFeeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 13,
                            "rule": "optional"
                          },
                          "depositToken": {
                            "type": "string",
                            "id": 14,
                            "rule": "optional"
                          },
                          "tenderedMoney": {
                            "type": ".squareup.common.Money",
                            "id": 20,
                            "rule": "optional"
                          },
                          "changeBackMoney": {
                            "type": ".squareup.common.Money",
                            "id": 21,
                            "rule": "optional"
                          },
                          "tipMoney": {
                            "type": ".squareup.common.Money",
                            "id": 22,
                            "rule": "optional"
                          },
                          "taxMoney": {
                            "type": ".squareup.common.Money",
                            "id": 26,
                            "rule": "optional"
                          },
                          "customer": {
                            "type": ".squareup.beemo.api.v2.models.Customer",
                            "id": 30,
                            "rule": "optional"
                          },
                          "surchargeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 31,
                            "rule": "optional"
                          },
                          "autoGratuityMoney": {
                            "type": ".squareup.common.Money",
                            "id": 32,
                            "rule": "optional"
                          },
                          "otherTenderType": {
                            "type": ".squareup.beemo.api.v2.models.Tender.OtherTenderType",
                            "id": 50,
                            "rule": "optional"
                          },
                          "otherTenderNameOrTranslationType": {
                            "type": ".squareup.beemo.translation_types.NameOrTranslationType",
                            "id": 51,
                            "rule": "optional"
                          },
                          "hashedGiftCardToken": {
                            "type": "string",
                            "id": 52,
                            "rule": "optional"
                          },
                          "sequentialTenderNumber": {
                            "type": "string",
                            "id": 53,
                            "rule": "optional"
                          },
                          "processingFeeAmounts": {
                            "type": ".squareup.beemo.api.v2.models.ProcessingFeeAmounts",
                            "id": 54,
                            "rule": "optional"
                          },
                          "giftCardToken": {
                            "type": "string",
                            "id": 55,
                            "rule": "optional"
                          },
                          "paymentEntryMethod": {
                            "type": ".squareup.common.payment.EntryMethod",
                            "id": 56,
                            "rule": "optional"
                          },
                          "settlementDetails": {
                            "type": ".squareup.bills.CardTender.SettlementDetails",
                            "id": 57,
                            "rule": "optional"
                          },
                          "refundCardPresenceRequirement": {
                            "type": ".squareup.bills.Tender.RefundCardPresenceRequirement",
                            "id": 58,
                            "rule": "optional",
                            "options": {
                              "default": "REFUND_CARD_PRESENCE_NOT_REQUIRED"
                            }
                          },
                          "externalTender": {
                            "type": ".squareup.beemo.api.v2.models.Tender.ExternalTender",
                            "id": 59,
                            "rule": "optional"
                          },
                          "contactDetails": {
                            "type": ".squareup.bills.ContactDetails",
                            "id": 61,
                            "rule": "optional"
                          },
                          "tenderedAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 62,
                            "rule": "optional"
                          },
                          "settledAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 63,
                            "rule": "optional"
                          },
                          "riskEvaluationDetails": {
                            "type": ".squareup.beemo.api.v2.models.Tender.RiskEvaluationDetails",
                            "id": 64,
                            "rule": "optional"
                          },
                          "pushTender": {
                            "type": ".squareup.beemo.api.v2.models.Tender.PushTender",
                            "id": 66,
                            "rule": "optional"
                          },
                          "squareAccountTender": {
                            "type": ".squareup.beemo.api.v2.models.Tender.SquareAccountTender",
                            "id": 69,
                            "rule": "optional"
                          },
                          "buyerCurrencyExchange": {
                            "type": ".squareup.connect.v2.CurrencyExchange",
                            "id": 70,
                            "rule": "optional"
                          },
                          "authorizationCode": {
                            "type": "string",
                            "id": 71,
                            "rule": "optional"
                          },
                          "settleInBitcoin": {
                            "type": "bool",
                            "id": 72,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Type": {
                            "values": {
                              "CREDIT_CARD": 1,
                              "CASH": 2,
                              "TAB": 3,
                              "SQUARE_GIFT_CARD": 4,
                              "NO_SALE": 5,
                              "ZERO_AMOUNT": 6,
                              "GENERIC": 7,
                              "BANK_TRANSFER": 8,
                              "SQUARE_BALANCE": 9,
                              "LEDGER": 10,
                              "SQUARE_CAPITAL": 11,
                              "EXTERNAL": 12,
                              "EMONEY": 13,
                              "PUSH_TENDER": 14,
                              "OPEN_TICKET": 15,
                              "SQUARE_ACCOUNT": 16,
                              "OTHER": 100
                            }
                          },
                          "OtherTenderType": {
                            "values": {
                              "CHECK": 1,
                              "MERCHANT_GIFT_CARD": 2,
                              "DEBIT": 3,
                              "CREDIT_OR_DEBIT": 4,
                              "E_MONEY": 5,
                              "DEBIT_OR_CREDIT": 6,
                              "THIRD_PARTY_CARD": 7,
                              "MEAL_VOUCHER": 8,
                              "HACKWEEK_CRYPTO": 9,
                              "HOUSE_ACCOUNT": 10,
                              "VENMO": 11,
                              "BITCOIN": 12,
                              "CUSTOM": 100,
                              "UNKNOWN": 101
                            }
                          },
                          "ExternalTender": {
                            "fields": {
                              "paymentSource": {
                                "type": ".squareup.beemo.api.v2.models.Tender.ExternalTender.PaymentSource",
                                "id": 1,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "PaymentSource": {
                                "fields": {
                                  "applicationId": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "applicationName": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  }
                                }
                              }
                            }
                          },
                          "RiskEvaluationDetails": {
                            "fields": {
                              "evaluationResult": {
                                "type": ".squareup.riskevaluation.external.EvaluationResult",
                                "id": 1,
                                "rule": "optional"
                              }
                            }
                          },
                          "PushTender": {
                            "fields": {
                              "cashAppTender": {
                                "type": ".squareup.beemo.api.v2.models.Tender.PushTender.CashAppTender",
                                "id": 1
                              },
                              "afterpayTender": {
                                "type": ".squareup.beemo.api.v2.models.Tender.PushTender.AfterPayTender",
                                "id": 2
                              },
                              "paypayTender": {
                                "type": ".squareup.beemo.api.v2.models.Tender.PushTender.PayPayTender",
                                "id": 3
                              },
                              "alipayTender": {
                                "type": ".squareup.beemo.api.v2.models.Tender.PushTender.AlipayTender",
                                "id": 4
                              },
                              "rakutenPayTender": {
                                "type": ".squareup.beemo.api.v2.models.Tender.PushTender.RakutenPayTender",
                                "id": 5
                              },
                              "auPayTender": {
                                "type": ".squareup.beemo.api.v2.models.Tender.PushTender.AuPayTender",
                                "id": 6
                              },
                              "dBaraiTender": {
                                "type": ".squareup.beemo.api.v2.models.Tender.PushTender.DBaraiTender",
                                "id": 7
                              },
                              "merpayTender": {
                                "type": ".squareup.beemo.api.v2.models.Tender.PushTender.MerpayTender",
                                "id": 8
                              },
                              "wechatPayTender": {
                                "type": ".squareup.beemo.api.v2.models.Tender.PushTender.WechatPayTender",
                                "id": 9
                              }
                            },
                            "nested": {
                              "CashAppTender": {
                                "fields": {
                                  "authorizationCode": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "pwcTransactionId": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "readOnlyCashtag": {
                                    "type": "string",
                                    "id": 3,
                                    "rule": "optional"
                                  },
                                  "readOnlyBuyerFullName": {
                                    "type": "string",
                                    "id": 4,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "AfterPayTender": {
                                "fields": {
                                  "afterpayTransactionId": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  },
                                  "readOnlyBuyerEmail": {
                                    "type": "string",
                                    "id": 2,
                                    "rule": "optional"
                                  },
                                  "readOnlyIsClearpayBranded": {
                                    "type": "bool",
                                    "id": 3,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "PayPayTender": {
                                "fields": {
                                  "paypayTransactionId": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "AlipayTender": {
                                "fields": {
                                  "alipayTransactionId": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "RakutenPayTender": {
                                "fields": {
                                  "rakutenPayTransactionId": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "AuPayTender": {
                                "fields": {
                                  "auPayTransactionId": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "DBaraiTender": {
                                "fields": {
                                  "dBaraiTransactionId": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "MerpayTender": {
                                "fields": {
                                  "merpayTransactionId": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "WechatPayTender": {
                                "fields": {
                                  "wechatPayTransactionId": {
                                    "type": "string",
                                    "id": 1,
                                    "rule": "optional"
                                  }
                                }
                              },
                              "push_type": {
                                "oneof": ["cashAppTender", "afterpayTender", "paypayTender", "alipayTender", "rakutenPayTender", "auPayTender", "dBaraiTender", "merpayTender", "wechatPayTender"]
                              }
                            }
                          },
                          "SquareAccountTender": {
                            "fields": {
                              "squareAccountToken": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "contactToken": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "primaryDisplayName": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "FullRefund": {
                        "fields": {
                          "type": {
                            "type": ".squareup.beemo.api.v2.models.FullRefund.RefundType",
                            "id": 1,
                            "rule": "optional"
                          },
                          "createdAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 2,
                            "rule": "optional"
                          },
                          "processedAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 3,
                            "rule": "optional"
                          },
                          "reason": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "refundedMoney": {
                            "type": ".squareup.common.Money",
                            "id": 5,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "RefundType": {
                            "values": {
                              "FULL_REFUND": 1
                            }
                          }
                        }
                      },
                      "Refund": {
                        "fields": {
                          "type": {
                            "type": ".squareup.beemo.api.v2.models.Refund.RefundType",
                            "id": 1,
                            "rule": "optional"
                          },
                          "createdAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 2,
                            "rule": "optional"
                          },
                          "processedAt": {
                            "type": ".squareup.common.time.DateTime",
                            "id": 3,
                            "rule": "optional"
                          },
                          "reason": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "refundedMoney": {
                            "type": ".squareup.common.Money",
                            "id": 5,
                            "rule": "optional"
                          },
                          "creatorDetails": {
                            "type": ".squareup.beemo.api.v2.models.CreatorDetails",
                            "id": 6,
                            "rule": "optional"
                          },
                          "refundedProductSalesMoney": {
                            "type": ".squareup.common.Money",
                            "id": 28,
                            "rule": "optional"
                          },
                          "refundedGrossSalesMoney": {
                            "type": ".squareup.common.Money",
                            "id": 11,
                            "rule": "optional"
                          },
                          "refundedDiscountMoney": {
                            "type": ".squareup.common.Money",
                            "id": 12,
                            "rule": "optional"
                          },
                          "refundedNetSalesMoney": {
                            "type": ".squareup.common.Money",
                            "id": 13,
                            "rule": "optional"
                          },
                          "refundedTipMoney": {
                            "type": ".squareup.common.Money",
                            "id": 14,
                            "rule": "optional"
                          },
                          "refundedInclusiveTaxMoney": {
                            "type": ".squareup.common.Money",
                            "id": 33,
                            "rule": "optional"
                          },
                          "refundedAdditiveTaxMoney": {
                            "type": ".squareup.common.Money",
                            "id": 34,
                            "rule": "optional"
                          },
                          "refundedTaxMoney": {
                            "type": ".squareup.common.Money",
                            "id": 15,
                            "rule": "optional"
                          },
                          "refundedCreditMoney": {
                            "type": ".squareup.common.Money",
                            "id": 16,
                            "rule": "optional"
                          },
                          "refundedTotalCollectedMoney": {
                            "type": ".squareup.common.Money",
                            "id": 17,
                            "rule": "optional"
                          },
                          "refundedProcessingFeeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 18,
                            "rule": "optional"
                          },
                          "refundedNetTotalMoney": {
                            "type": ".squareup.common.Money",
                            "id": 19,
                            "rule": "optional"
                          },
                          "paymentToken": {
                            "type": "string",
                            "id": 22,
                            "rule": "optional"
                          },
                          "refundUuid": {
                            "type": "string",
                            "id": 23,
                            "rule": "optional"
                          },
                          "refundId": {
                            "type": "string",
                            "id": 24,
                            "rule": "optional"
                          },
                          "refundedSurchargeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 25,
                            "rule": "optional"
                          },
                          "refundedSurchargeInclusiveTaxMoney": {
                            "type": ".squareup.common.Money",
                            "id": 26,
                            "rule": "optional"
                          },
                          "refundedProcessingFeeAmounts": {
                            "type": ".squareup.beemo.api.v2.models.ProcessingFeeAmounts",
                            "id": 27,
                            "rule": "optional"
                          },
                          "destination": {
                            "type": ".squareup.bills.Refund.Destination",
                            "id": 29,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "RefundType": {
                            "values": {
                              "FULL_REFUND": 1,
                              "PARTIAL_REFUND": 2,
                              "ITEMIZED_REFUND": 3
                            }
                          }
                        }
                      },
                      "ProcessingFeeAmounts": {
                        "fields": {
                          "squareProcessingFeeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "taxOnProcessingFeeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "squareProcessingFeeAmountDetails": {
                            "type": ".squareup.beemo.api.v2.models.SquareProcessingFeeAmountDetails",
                            "id": 3,
                            "rule": "optional"
                          },
                          "thirdPartyFeeAmountDetails": {
                            "type": ".squareup.beemo.api.v2.models.ThirdPartyFeeAmountDetail",
                            "id": 4,
                            "rule": "repeated"
                          },
                          "squareProcessingFeeAmountDetailList": {
                            "type": ".squareup.beemo.api.v2.models.SquareProcessingFeeAmountDetails",
                            "id": 5,
                            "rule": "repeated"
                          }
                        }
                      },
                      "SquareProcessingFeeAmountDetails": {
                        "fields": {
                          "initialFeeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "initialTaxOnFeeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 8,
                            "rule": "optional"
                          },
                          "adjustmentFeeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "adjustmentFee": {
                            "type": ".squareup.beemo.api.v2.models.SquareProcessingFeeAmountDetails.AdjustmentFee",
                            "id": 3,
                            "rule": "repeated"
                          },
                          "feeType": {
                            "type": ".squareup.beemo.api.v2.models.SquareProcessingFeeAmountDetails.FeeType",
                            "id": 4,
                            "rule": "optional"
                          },
                          "feePlan": {
                            "type": ".squareup.beemo.api.v2.models.SquareProcessingFeeAmountDetails.FeePlan",
                            "id": 5,
                            "rule": "optional"
                          },
                          "taxOnProcessingFeeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 6,
                            "rule": "optional"
                          },
                          "freeProcessingFeeMoney": {
                            "type": ".squareup.common.Money",
                            "id": 7,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "AdjustmentFee": {
                            "fields": {
                              "money": {
                                "type": ".squareup.common.Money",
                                "id": 1,
                                "rule": "optional"
                              },
                              "taxOnFeeMoney": {
                                "type": ".squareup.common.Money",
                                "id": 3,
                                "rule": "optional"
                              },
                              "adjustedAt": {
                                "type": ".squareup.common.time.DateTime",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "FeeType": {
                            "values": {
                              "FIXED_RATE": 0,
                              "COST_PLUS": 1,
                              "NOT_APPLICABLE": 1000
                            }
                          },
                          "FeePlan": {
                            "fields": {
                              "discountBasisPoints": {
                                "type": "int64",
                                "id": 1,
                                "rule": "optional"
                              },
                              "interchangeCents": {
                                "type": "int64",
                                "id": 2,
                                "rule": "optional"
                              },
                              "feePlanProduct": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              },
                              "feePlanId": {
                                "type": "string",
                                "id": 4,
                                "rule": "optional"
                              },
                              "taxRateBasisPoints": {
                                "type": "int64",
                                "id": 5,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "ThirdPartyFeeAmountDetail": {
                        "fields": {
                          "amount": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "thirdPartyFeeEntity": {
                            "type": ".squareup.beemo.api.v2.models.ThirdPartyFeeEntity",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "ThirdPartyFeeEntity": {
                        "fields": {
                          "unitToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "displayName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Tender && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Tender?.nested?.Type && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Tender?.nested?.OtherTenderType && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Tender?.nested?.ExternalTender && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Tender?.nested?.ExternalTender?.nested?.PaymentSource && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Tender?.nested?.RiskEvaluationDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Tender?.nested?.PushTender && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Tender?.nested?.PushTender?.nested?.CashAppTender && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Tender?.nested?.PushTender?.nested?.AfterPayTender && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Tender?.nested?.PushTender?.nested?.PayPayTender && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Tender?.nested?.PushTender?.nested?.AlipayTender && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Tender?.nested?.PushTender?.nested?.RakutenPayTender && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Tender?.nested?.PushTender?.nested?.AuPayTender && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Tender?.nested?.PushTender?.nested?.DBaraiTender && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Tender?.nested?.PushTender?.nested?.MerpayTender && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Tender?.nested?.PushTender?.nested?.WechatPayTender && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Tender?.nested?.SquareAccountTender && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.FullRefund && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.FullRefund?.nested?.RefundType && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Refund && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.Refund?.nested?.RefundType && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.ProcessingFeeAmounts && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.SquareProcessingFeeAmountDetails && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.SquareProcessingFeeAmountDetails?.nested?.AdjustmentFee && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.SquareProcessingFeeAmountDetails?.nested?.FeeType && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.SquareProcessingFeeAmountDetails?.nested?.FeePlan && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.ThirdPartyFeeAmountDetail && !$root.nested?.squareup?.nested?.beemo?.nested?.api?.nested?.v2?.nested?.models?.nested?.ThirdPartyFeeEntity) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Tender @ squareup/beemo/v2/models/payment.proto at 21:1
 */
export const Tender = $root.lookupType('squareup.beemo.api.v2.models.Tender');
fixType(Tender);
Builder.createAndAttachToType(Tender);
/**
 * SOURCE Type @ squareup/beemo/v2/models/payment.proto at 22:3
 */
Tender.Type = $root.lookupEnum('squareup.beemo.api.v2.models.Tender.Type').values;
/**
 * Other Tender Payment fields.
 * This enum is owned in sq/web at https://git.sqcorp.co/square/web/blob/master/config/other_tenders.yml
 *
 * SOURCE OtherTenderType @ squareup/beemo/v2/models/payment.proto at 157:3
 */
Tender.OtherTenderType = $root.lookupEnum('squareup.beemo.api.v2.models.Tender.OtherTenderType').values;
/**
 * A payment taken and processed by an external integration, e.g. Caviar.
 *
 * SOURCE ExternalTender @ squareup/beemo/v2/models/payment.proto at 218:3
 */
Tender.ExternalTender = $root.lookupType('squareup.beemo.api.v2.models.Tender.ExternalTender');
fixType(Tender.ExternalTender);
Builder.createAndAttachToType(Tender.ExternalTender);
/**
 * SOURCE PaymentSource @ squareup/beemo/v2/models/payment.proto at 219:5
 */
Tender.ExternalTender.PaymentSource = $root.lookupType('squareup.beemo.api.v2.models.Tender.ExternalTender.PaymentSource');
fixType(Tender.ExternalTender.PaymentSource);
Builder.createAndAttachToType(Tender.ExternalTender.PaymentSource);
/**
 * Merchant facing risk evaluation result
 * See https://go.sqprod.co/external-risk-evaluation-design-doc
 *
 * SOURCE RiskEvaluationDetails @ squareup/beemo/v2/models/payment.proto at 246:3
 */
Tender.RiskEvaluationDetails = $root.lookupType('squareup.beemo.api.v2.models.Tender.RiskEvaluationDetails');
fixType(Tender.RiskEvaluationDetails);
Builder.createAndAttachToType(Tender.RiskEvaluationDetails);
/**
 * SOURCE PushTender @ squareup/beemo/v2/models/payment.proto at 257:3
 */
Tender.PushTender = $root.lookupType('squareup.beemo.api.v2.models.Tender.PushTender');
fixType(Tender.PushTender);
Builder.createAndAttachToType(Tender.PushTender);
/**
 * Using Square Cash App to pay.
 *
 * SOURCE CashAppTender @ squareup/beemo/v2/models/payment.proto at 271:5
 */
Tender.PushTender.CashAppTender = $root.lookupType('squareup.beemo.api.v2.models.Tender.PushTender.CashAppTender');
fixType(Tender.PushTender.CashAppTender);
Builder.createAndAttachToType(Tender.PushTender.CashAppTender);
/**
 * SOURCE AfterPayTender @ squareup/beemo/v2/models/payment.proto at 289:5
 */
Tender.PushTender.AfterPayTender = $root.lookupType('squareup.beemo.api.v2.models.Tender.PushTender.AfterPayTender');
fixType(Tender.PushTender.AfterPayTender);
Builder.createAndAttachToType(Tender.PushTender.AfterPayTender);
/**
 * SOURCE PayPayTender @ squareup/beemo/v2/models/payment.proto at 307:5
 */
Tender.PushTender.PayPayTender = $root.lookupType('squareup.beemo.api.v2.models.Tender.PushTender.PayPayTender');
fixType(Tender.PushTender.PayPayTender);
Builder.createAndAttachToType(Tender.PushTender.PayPayTender);
/**
 * SOURCE AlipayTender @ squareup/beemo/v2/models/payment.proto at 314:5
 */
Tender.PushTender.AlipayTender = $root.lookupType('squareup.beemo.api.v2.models.Tender.PushTender.AlipayTender');
fixType(Tender.PushTender.AlipayTender);
Builder.createAndAttachToType(Tender.PushTender.AlipayTender);
/**
 * SOURCE RakutenPayTender @ squareup/beemo/v2/models/payment.proto at 321:5
 */
Tender.PushTender.RakutenPayTender = $root.lookupType('squareup.beemo.api.v2.models.Tender.PushTender.RakutenPayTender');
fixType(Tender.PushTender.RakutenPayTender);
Builder.createAndAttachToType(Tender.PushTender.RakutenPayTender);
/**
 * SOURCE AuPayTender @ squareup/beemo/v2/models/payment.proto at 328:5
 */
Tender.PushTender.AuPayTender = $root.lookupType('squareup.beemo.api.v2.models.Tender.PushTender.AuPayTender');
fixType(Tender.PushTender.AuPayTender);
Builder.createAndAttachToType(Tender.PushTender.AuPayTender);
/**
 * SOURCE DBaraiTender @ squareup/beemo/v2/models/payment.proto at 335:5
 */
Tender.PushTender.DBaraiTender = $root.lookupType('squareup.beemo.api.v2.models.Tender.PushTender.DBaraiTender');
fixType(Tender.PushTender.DBaraiTender);
Builder.createAndAttachToType(Tender.PushTender.DBaraiTender);
/**
 * SOURCE MerpayTender @ squareup/beemo/v2/models/payment.proto at 342:5
 */
Tender.PushTender.MerpayTender = $root.lookupType('squareup.beemo.api.v2.models.Tender.PushTender.MerpayTender');
fixType(Tender.PushTender.MerpayTender);
Builder.createAndAttachToType(Tender.PushTender.MerpayTender);
/**
 * SOURCE WechatPayTender @ squareup/beemo/v2/models/payment.proto at 349:5
 */
Tender.PushTender.WechatPayTender = $root.lookupType('squareup.beemo.api.v2.models.Tender.PushTender.WechatPayTender');
fixType(Tender.PushTender.WechatPayTender);
Builder.createAndAttachToType(Tender.PushTender.WechatPayTender);
/**
 * Tender for House Account
 *
 * SOURCE SquareAccountTender @ squareup/beemo/v2/models/payment.proto at 360:3
 */
Tender.SquareAccountTender = $root.lookupType('squareup.beemo.api.v2.models.Tender.SquareAccountTender');
fixType(Tender.SquareAccountTender);
Builder.createAndAttachToType(Tender.SquareAccountTender);
/**
 * Deprecated
 *
 * SOURCE FullRefund @ squareup/beemo/v2/models/payment.proto at 395:1
 */
export const FullRefund = $root.lookupType('squareup.beemo.api.v2.models.FullRefund');
fixType(FullRefund);
Builder.createAndAttachToType(FullRefund);
/**
 * SOURCE RefundType @ squareup/beemo/v2/models/payment.proto at 396:3
 */
FullRefund.RefundType = $root.lookupEnum('squareup.beemo.api.v2.models.FullRefund.RefundType').values;
/**
 * SOURCE Refund @ squareup/beemo/v2/models/payment.proto at 411:1
 */
export const Refund = $root.lookupType('squareup.beemo.api.v2.models.Refund');
fixType(Refund);
Builder.createAndAttachToType(Refund);
/**
 * SOURCE RefundType @ squareup/beemo/v2/models/payment.proto at 412:3
 */
Refund.RefundType = $root.lookupEnum('squareup.beemo.api.v2.models.Refund.RefundType').values;
/**
 * SOURCE ProcessingFeeAmounts @ squareup/beemo/v2/models/payment.proto at 522:1
 */
export const ProcessingFeeAmounts = $root.lookupType('squareup.beemo.api.v2.models.ProcessingFeeAmounts');
fixType(ProcessingFeeAmounts);
Builder.createAndAttachToType(ProcessingFeeAmounts);
/**
 * Additional breakdown of square_processing_fee_money. Set when a tender has fee adjustment.
 * The field is used for Cost+ as of 2016 Q3.
 *
 * The following invariant holds:
 *   initial_fee_money + sum(adjustment_fee_money) = square_processing_fee_money.
 *   initial_tax_on_fee_money + sum(adjustment_fee.tax_on_fee_money) =
 *           ProcessingFeeAmounts.tax_on_processing_fee_money.
 *
 * This protocol message mirrors SquareProcessingFeeAmountDetails in the bill Tender proto.
 *
 * SOURCE SquareProcessingFeeAmountDetails @ squareup/beemo/v2/models/payment.proto at 546:1
 */
export const SquareProcessingFeeAmountDetails = $root.lookupType('squareup.beemo.api.v2.models.SquareProcessingFeeAmountDetails');
fixType(SquareProcessingFeeAmountDetails);
Builder.createAndAttachToType(SquareProcessingFeeAmountDetails);
/**
 * This is only populated for the top level SquareProcessingFeeAmountDetails, not for the
 * repeated fields
 * An AdjustmentFee is composed of a fee, and a tax on the fee.
 * The total adjusted fee including tax is (money + tax_on_fee_money).
 * Tax on fee adjustments are only used for Cost+ AU as of Q4 2020.
 *
 * SOURCE AdjustmentFee @ squareup/beemo/v2/models/payment.proto at 579:3
 */
SquareProcessingFeeAmountDetails.AdjustmentFee = $root.lookupType('squareup.beemo.api.v2.models.SquareProcessingFeeAmountDetails.AdjustmentFee');
fixType(SquareProcessingFeeAmountDetails.AdjustmentFee);
Builder.createAndAttachToType(SquareProcessingFeeAmountDetails.AdjustmentFee);
/**
 * Type of the fee.
 *
 * SOURCE FeeType @ squareup/beemo/v2/models/payment.proto at 607:3
 */
SquareProcessingFeeAmountDetails.FeeType = $root.lookupEnum('squareup.beemo.api.v2.models.SquareProcessingFeeAmountDetails.FeeType').values;
/**
 * The processing fee plan breakdown.
 * For 2.75% FIXED_RATE processing, |discount_basis_points| is 275 and |interchange_cents| is 0.
 * For 2.50% FIXED_RATE + 10 cents processing, |discount_basis_points| is 250 and |interchange_cents| is 10.
 *
 * SOURCE FeePlan @ squareup/beemo/v2/models/payment.proto at 622:3
 */
SquareProcessingFeeAmountDetails.FeePlan = $root.lookupType('squareup.beemo.api.v2.models.SquareProcessingFeeAmountDetails.FeePlan');
fixType(SquareProcessingFeeAmountDetails.FeePlan);
Builder.createAndAttachToType(SquareProcessingFeeAmountDetails.FeePlan);
/**
 * Details about each ThirdPartyFee assessed on this Tender.
 *
 * SOURCE ThirdPartyFeeAmountDetail @ squareup/beemo/v2/models/payment.proto at 659:1
 */
export const ThirdPartyFeeAmountDetail = $root.lookupType('squareup.beemo.api.v2.models.ThirdPartyFeeAmountDetail');
fixType(ThirdPartyFeeAmountDetail);
Builder.createAndAttachToType(ThirdPartyFeeAmountDetail);
/**
 * SOURCE ThirdPartyFeeEntity @ squareup/beemo/v2/models/payment.proto at 668:1
 */
export const ThirdPartyFeeEntity = $root.lookupType('squareup.beemo.api.v2.models.ThirdPartyFeeEntity');
fixType(ThirdPartyFeeEntity);
Builder.createAndAttachToType(ThirdPartyFeeEntity);